import styled, { css } from 'styled-components';
import { theme, toRem } from 'design';

// UI
export const MPContent = styled.div<{ $smallGutter?: boolean }>`
  position: relative;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  height: auto;
  padding: 0 ${toRem(theme.layout.gutter.small)};

  @media (min-width: ${theme.breakpoint.small}px) {
    padding: 0 ${toRem(theme.layout.gutter.med)};

    ${({ $smallGutter }) =>
      $smallGutter &&
      css`
        padding: 0 ${toRem(theme.layout.gutter.small)};
      `}
  }
`;
